import styled, { css } from 'styled-components'

/** A4 landscape — evita overflow que gerava 4 páginas em branco no print (TIVENT-2083) */
const paginaCertificado = css`
  background-color: #ffffff;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.15);
  display: flex;
  width: 100%;
  min-height: 595px;
  position: relative;
  overflow: hidden;

  @media print {
    box-shadow: none;
    width: 297mm;
    height: 210mm;
    min-height: 210mm;
    max-height: 210mm;
    overflow: hidden;
    page-break-inside: avoid;
  }
`

export const PaginaFrente = styled.div`
  ${paginaCertificado}

  @media print {
    page-break-after: always;
  }
`

export const PaginaVerso = styled.div`
  ${paginaCertificado}

  display: none;

  @media print {
    display: flex;
    page-break-after: auto;
  }
`

/** Frente: PNG 262×792. Não reutilizar o max-width do verso — 90px/28mm + cover corta o chevron. */
export const BordaLateralFrente = styled.img`
  display: block;
  align-self: stretch;
  height: auto;
  width: auto;
  aspect-ratio: 262 / 792;
  object-fit: contain;
  object-position: top left;
  flex-shrink: 0;

  @media print {
    height: 210mm;
    max-height: 210mm;
    width: auto;
    max-width: 72mm;
  }
`

/** Verso: PNGs ~230–262 × 1999. 28mm ≈ largura natural em A4 landscape. */
export const BordaLateral = styled.img`
  height: 100%;
  width: auto;
  max-width: 90px;
  object-fit: cover;
  object-position: top left;
  flex-shrink: 0;

  @media print {
    height: 210mm;
    max-height: 210mm;
    max-width: 28mm;
    width: auto;
  }
`

export const BordaDireita = styled(BordaLateral)`
  object-position: top right;
`

export const AreaConteudo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 32px 16px;
  min-width: 0;
  min-height: 0;
  overflow: hidden;

  @media print {
    padding: 12mm 14mm 8mm;
  }
`

export const LogoTopo = styled.img`
  width: 280px;
  max-width: 100%;
  height: auto;
  margin: 0 auto 12px;
  display: block;

  @media print {
    width: 90mm;
    margin-bottom: 6mm;
  }
`

export const TituloPrincipal = styled.h1`
  color: #4f2f7d;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 8px;
  letter-spacing: 0.5px;

  @media print {
    font-size: 28pt;
    margin-bottom: 3mm;
  }
`

export const Subtitulo = styled.h2`
  color: #865ebf;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 24px;

  @media print {
    font-size: 18pt;
    margin-bottom: 8mm;
  }
`

export const TextoCorpo = styled.p`
  color: #000000;
  font-size: 17px;
  text-align: center;
  margin: 0 0 16px;
  line-height: 1.4;

  @media print {
    font-size: 14pt;
    margin-bottom: 5mm;
  }
`

export const NomeAluno = styled.p`
  color: #4f2f7d;
  font-size: 26px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 20px;

  &.nome-placeholder {
    opacity: 0.45;
    font-style: italic;
    font-weight: 500;
  }

  @media print {
    font-size: 20pt;
    margin-bottom: 6mm;
  }
`

export const DataLocal = styled.p`
  color: #000000;
  font-size: 18px;
  text-align: center;
  margin: 0 0 auto;
  padding-top: 8px;

  @media print {
    font-size: 13pt;
  }
`

export const RodapeFrente = styled.div`
  margin-top: auto;
  padding-top: 12px;
  flex-shrink: 0;

  @media print {
    padding-top: 4mm;
  }
`

export const LinhaAssinaturaQr = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
`

export const AreaAssinatura = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 180px;
    max-width: 100%;
    height: auto;
  }

  @media print {
    img {
      width: 45mm;
    }
  }
`

export const LinhaAssinatura = styled.div`
  width: 220px;
  border-bottom: 1px solid #000;
  margin-top: -4px;

  @media print {
    width: 55mm;
  }
`

export const AreaQrCode = styled.div`
  flex-shrink: 0;

  canvas,
  svg {
    display: block;
  }
`

export const LegendaRodape = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 11px;
  color: #082749;
  gap: 8px;
  padding: 0 8px;

  span {
    flex: 1;
    text-align: center;
    line-height: 1.3;
  }

  .secundario {
    font-size: 10px;
    color: #082749;
  }

  @media print {
    font-size: 9pt;

    .secundario {
      font-size: 8pt;
    }
  }
`

export const CabecalhoVerso = styled.h1`
  background-color: #c59dff;
  color: #000000;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  padding: 6px 12px;
  margin: 0 0 20px;
  letter-spacing: 0.3px;
  flex-shrink: 0;

  @media print {
    font-size: 11pt;
    padding: 3mm 4mm;
    margin-bottom: 5mm;
  }
`

export const ConteudoVerso = styled.div`
  flex: 1;
  overflow: hidden;
  min-height: 0;

  p,
  li {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 8px;
  }

  @media print {
    p,
    li {
      font-size: 10pt;
      margin-bottom: 2mm;
    }
  }
`

export const RodapeVerso = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: auto;
  padding-top: 16px;
  flex-shrink: 0;

  @media print {
    padding-top: 4mm;
    gap: 8mm;
  }
`

export const RealizacaoVerso = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 700;
  color: #000;

  img {
    width: 220px;
    height: auto;
  }

  @media print {
    font-size: 12pt;

    img {
      width: 60mm;
    }
  }
`

export const ContainerCertificadoExtensao = styled.div`
  @media print {
    @page {
      size: A4 landscape;
      margin: 0;
    }
  }
`
